/* eslint-disable */
import toast from '../../services/toast';
const $ = window.jQuery = require('jquery'); 
import {
  bus
} from '../../main';
export default {
  name: 'contest-feedback-form',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      feedback:'',
      entity_id:'',
      entity_name:'',
      entity_type:'',
      contestDetails:{}
    }
  },
  computed: {

  },
  mounted () {
  // USER_FEEDBACK_TYPES = [
  //     (1, "General"),
  //     (2, "Course"),
  //     (3, "Quiz")
  // ]
  this.contestDetails = JSON.parse(localStorage.getItem('contestDetails'))
  let _self = this;
  $(document).ready(function (argument) {
  $(document).click(function(event) {
    //if you click on anything except the modal itself or the "open modal" link, close the modal
    if (!$(event.target).closest(".feeadback_form_inner, .contest_feedback_wrp .btn").length) {
      _self.feedbackFormCloseFun()
    }
  });
});
  },
  methods: {
    validateAddUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            entity_id:this.$route.params.quizId,
            entity_name:this.contestDetails.name,
            entity_type:3,
            feedback:this.feedback,
          }
          this.$store.dispatch('createdFeedbackOfContestFun', data).then((res) => {
              toast.success(res.msg);
              this.feedback = ''
              this.$validator.reset();
              bus.$emit('contestFeedbackBus', false);
              bus.$emit('checkContestFeedbackBtnBus', false);
          }).catch((err) => {
            toast.error(err.msg);
          })
          return;
        }
      })
    },
    feedbackFormCloseFun(){
      bus.$emit('contestFeedbackBus', false);
    }
  }
}